// extracted by css-extract-rspack-plugin
module.exports =  {"category":"Category-OKfq__category","dropzone":"Category-M17K__dropzone","header":"Category-Kh2i__header","items":"Category-ycRW__items"};